<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry">
<p class="contentsEntryName"><a href="#/xhtml/epi01#epi01">Epigraph</a></p>
</div>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter01#ch01">One</a></p>
<p class="contentsEntryName">Artie</p>
</div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter02#ch02">Two</a></p>
<p class="contentsEntryName">Mobile Bay</p>
</div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter03#ch03">Three</a></p>
<p class="contentsEntryName">Dream Catchers</p>
</div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter04#ch04">Four</a></p>
<p class="contentsEntryName">Almond Pie</p>
</div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><a href="#/xhtml/chapter05#ch05">Five</a></p>
<p class="contentsEntryName">Banana Republic Shirts</p>
</div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter06#ch06" title="Link target outside of Sample">Six</span></p>
<p class="contentsEntryName">Shifting Gears</p>
</div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter07#ch07" title="Link target outside of Sample">Seven</span></p>
<p class="contentsEntryName">Chowchow Pickles</p>
</div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter08#ch08" title="Link target outside of Sample">Eight</span></p>
<p class="contentsEntryName">Tomato Sandwiches</p>
</div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter09#ch09" title="Link target outside of Sample">Nine</span></p>
<p class="contentsEntryName">Peach Cobbler</p>
</div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Ten</span></p>
<p class="contentsEntryName">Shelling Peas</p>
</div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Eleven</span></p>
<p class="contentsEntryName">A Groom’s Cake with Green Grapes</p>
</div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Twelve</span></p>
<p class="contentsEntryName">Space Genes</p>
</div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Thirteen</span></p>
<p class="contentsEntryName">Artie on Her Fifteenth Birthday</p>
</div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">Fourteen</span></p>
<p class="contentsEntryName">Armadillos</p>
</div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Fifteen</span></p>
<p class="contentsEntryName">Our Glorious Dead</p>
</div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Sixteen</span></p>
<p class="contentsEntryName">A Circle Humming</p>
</div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">Seventeen</span></p>
<p class="contentsEntryName">Daylilies</p>
</div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Eighteen</span></p>
<p class="contentsEntryName">Northern Lights</p>
</div>
<div class="contentsEntry" id="ch_19">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Nineteen</span></p>
<p class="contentsEntryName">A White Dinner Jacket</p>
</div>
<div class="contentsEntry" id="ch_20">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">Twenty</span></p>
<p class="contentsEntryName">Naomi Cates and the Space-Time Continuum</p>
</div>
<div class="contentsEntry" id="ch_21">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Twenty-One</span></p>
<p class="contentsEntryName">Barbie Dolls</p>
</div>
<div class="contentsEntry" id="ch_22">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">Twenty-Two</span></p>
<p class="contentsEntryName">Christmas Lights</p>
</div>
<div class="contentsEntry" id="ch_23">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Twenty-Three</span></p>
<p class="contentsEntryName">Four Women</p>
</div>
<div class="contentsEntry" id="ch_24">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Twenty-Four</span></p>
<p class="contentsEntryName">Sarah Sullivan Explains to the Devil, 1940</p>
</div>
<div class="contentsEntry" id="ch_25">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Twenty-Five</span></p>
<p class="contentsEntryName">Doors</p>
</div>
<div class="contentsEntry" id="ch_26">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">Twenty-Six</span></p>
<p class="contentsEntryName">Unexpected Things</p>
</div>
<div class="contentsEntry" id="ch_27">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample">Twenty-Seven</span></p>
<p class="contentsEntryName">Thomas and Sarah Sullivan, August 5, 1946</p>
</div>
<div class="contentsEntry" id="ch_28">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample">Twenty-Eight</span></p>
<p class="contentsEntryName">One Life to Live</p>
</div>
<div class="contentsEntry" id="ch_29">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample">Twenty-Nine</span></p>
<p class="contentsEntryName">Hektor and the Devil</p>
</div>
<div class="contentsEntry" id="ch_30">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample">Thirty</span></p>
<p class="contentsEntryName">What Naomi Cates Will Never Tell Dolly</p>
</div>
<div class="contentsEntry" id="ch_31">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample">Thirty-One</span></p>
<p class="contentsEntryName">A Letter to Dolly, Never Mailed</p>
</div>
<div class="contentsEntry" id="ch_32">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample">Thirty-Two</span></p>
<p class="contentsEntryName">Sunrise, Sunset</p>
</div>
<div class="contentsEntry" id="ch_33">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample">Thirty-Three</span></p>
<p class="contentsEntryName">A Fine Rosary</p>
</div>
<div class="contentsEntry" id="ch_34">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample">Thirty-Four</span></p>
<p class="contentsEntryName">Something in Particular</p>
</div>
<div class="contentsEntry" id="ch_35">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample">Thirty-Five</span></p>
<p class="contentsEntryName">Perseus</p>
</div>
<div class="contentsEntry" id="ch_36">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample">Thirty-Six</span></p>
<p class="contentsEntryName">A Cut-Glass Pickle Dish</p>
</div>
<div class="contentsEntry" id="ch_37">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter37#ch37" title="Link target outside of Sample">Thirty-Seven</span></p>
<p class="contentsEntryName">Seeds</p>
</div>
<div class="contentsEntry" id="ch_38">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter38#ch38" title="Link target outside of Sample">Thirty-Eight</span></p>
<p class="contentsEntryName">Artie on Her Thirty-second Birthday</p>
</div>
<div class="contentsEntry" id="ch_39">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter39#ch39" title="Link target outside of Sample">Thirty-Nine</span></p>
<p class="contentsEntryName">The Devil’s Grave</p>
</div>
<div class="contentsEntry" id="ch_40">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter40#ch40" title="Link target outside of Sample">Forty</span></p>
<p class="contentsEntryName">The Wishbone</p>
</div>
<div class="contentsEntry" id="ch_41">
<p class="contentsEntryNumber"><span href="#/xhtml/chapter41#ch41" title="Link target outside of Sample">Forty-One</span></p>
<p class="contentsEntryName">Waiting for Artie</p>
</div>
<div class="contentsEntry" id="ata_01">
<p class="contentsEntryName"><span href="#/xhtml/ata01#ata01" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry" id="cop_01">
<p class="contentsEntryName"><span href="#/xhtml/copy#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry" id="atp_01">
<p class="contentsEntryName"><span href="#/xhtml/atp01#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?cde9dc32